/**
 *
 * Created by showzyl on 2017/9/26
 *
 * 处理请求数据后的逻辑
 *
 **/

import util from 'common/js/util.js'
import common from 'common/js/common.js'
import $ from 'jquery'

const $body = $('body')
const $sound = $('#sound')
const $close = $('#close')


function handleData() {
  let data = JSON.parse($body.data('data'))
  let unitSetting = data.unitSetting
  let layout = util.getUrlParams('layout')

  //判断服务端返回默认声音状态
  let voiceMute = data && data.sdkSetting && data.sdkSetting.playVideoMute

  // 设置声音默认状态为开启
  $sound.attr('data-mute', 0)

  // mock 数据

  // video_skip_time 若值为-1，则不显示X；若值为0，则一直显示X；若值为n，则在第n秒显示X。
  // unitSetting.video_skip_time = 3

  // // video_interactive_type 0：视频播放开始时，banner一直存在  -2 点击出现 minicard
  // // n：播放过程中第n秒时，出现cta按扭，且一直保留到视频结束。
  // unitSetting.video_interactive_type = -1
  // $body.data('data', JSON.stringify(data))


  $close.attr('video_skip_time', unitSetting.video_skip_time)
  // 默认不出关闭按钮
  $close.attr('needCloseBtn', '0')
  // video_skip_result 1为直接关闭，2出现endcard
  $close.attr('video_skip_result', unitSetting.video_skip_result)

  let inter_type = unitSetting.video_interactive_type

  // 不需要出 banner
  if (layout === '3' ||
    layout === '5' ||
    layout === '6') {
    return
  }

  $body.attr('interactive_type', inter_type)

  if (inter_type === 0) {
    $body.attr('banner', inter_type)
    common.showVideoClickView()
  } else if (inter_type > 0) {
    $body.attr('banner', inter_type)
    _showBanner(inter_type)
  }
}


function _showBanner(inter_type) {
  console.log('_showBanner')
  inter_type = Number(inter_type)

  setTimeout(function () {
    // 出现 banner
    common.showVideoClickView()
  }, inter_type * 1000)

}


export {
  handleData
}



// WEBPACK FOOTER //
// ./src/rv/splash/components/handledata.js